import React, {useState, useEffect} from 'react';
import {Text} from '@100mslive/roomkit-react';
import {ErrorDialog} from './../primitives/DialogContent';
import { getMeetingErrorData } from '../../utils/CommonUtils';
import { IMeetingErrorData } from './interfaces';

export const InitErrorModal = ({notification}: any) => {
  const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState<IMeetingErrorData>({
    title: 'Init Error',
    description: '',
  });

  useEffect(() => {
    const data = notification?.data;
    if (!data || data.action !== 'INIT') {
      return;
    }
    const errorData: IMeetingErrorData = getMeetingErrorData(data);
    setInfo((prev) => {
      return {
        ...prev,
        title: errorData.title,
        description: errorData.description,
      };
    });
    setShowModal(true);
  }, [notification]);

  return (
    <ErrorDialog
      open={showModal}
      onOpenChange={setShowModal}
      title={info.title}>
      <Text variant="sm" css={{wordBreak: 'break-all'}}>
        {info.description} Current URL - {window.location.href}
      </Text>
    </ErrorDialog>
  );
};
